import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

export const Icon = (props) => {

    if (props.isRight) {
        return (
            <span style={props.wrapperStyle} className={`is-clearfix icon-wrapper ${props.className}`}>
                <span className="is-pulled-left icon-text" style={props.textStyle}>{props.text}</span>
                <i className="fa material-icons is-pulled-left" style={props.iconStyle}>{props.icon}</i>
            </span>
        );
    }

    if (props.isOverlay) {
        return (
            <span style={props.wrapperStyle} className={`is-clearfix overlay-wrapper icon-wrapper ${props.className}`}>
                <i className="fa material-icons" style={props.iconStyle}>{props.icon}</i>
                <span className="icon-text overlay-text" style={props.textStyle}>{props.text}</span>
            </span>
        );
    }

    if (props.isLongText) {
        return (
            <span style={props.wrapperStyle} className={`is-clearfix icon-wrapper ${props.className}`}>
                <span className="is-pulled-left icon-text" style={props.textStyle}>
                    <i className="fa material-icons is-pulled-left" style={props.iconStyle}>
                        {props.icon}
                    </i>
                    {props.text}
                </span>
            </span>
        );
    }

    return (
        <span style={props.wrapperStyle} className={`is-clearfix icon-wrapper ${props.className}`}>
            <i className="fa material-icons is-pulled-left" style={props.iconStyle}>{props.icon}</i>
            <span className="is-pulled-left icon-text" style={props.textStyle}>{props.text}</span>
        </span>
    );
};

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([
        PropTypes.string, PropTypes.element, PropTypes.number
    ]),
    className: PropTypes.string,
    iconStyle: PropTypes.object,
    textStyle: PropTypes.object,
    wrapperStyle: PropTypes.object,
    isRight: PropTypes.bool,
    isOverlay: PropTypes.bool,
    isLongText: PropTypes.bool
};

Icon.defaultProps = {
    className: '',
    iconStyle: {},
    textStyle: {},
    wrapperStyle: {},
    isRight: false,
    isOverlay: false,
    isLongText: false
};

export default Icon;
